/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */

import React from "react";
import { Result } from 'antd';
class ErrorPage extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            status:'404',
            errTxt:'出错啦，未找到页面'
        }
    }
    componentDidMount() {
        const search = this.props.location.search;
        const paramsString = search.substring(1)
        const searchParams = new URLSearchParams(paramsString);
        const pathname = this.props.location.pathname;
        if(pathname==='/error'){
            if(searchParams.get('status')==='noAuth'){
                this.setState({status:'403',errTxt:'你没有访问该页面的权限'});
            }else{
                this.setState({status:'500',errTxt:'服务器出错'});
            }
        }else{
            this.setState({status:'404',errTxt:'出错啦，未找到页面'});
        }
    }
    render(){
        return(
            <Result
                status={this.state.status}
                title={this.state.status}
                subTitle={this.state.errTxt}

            />
        )
    }
}
export default ErrorPage
